import React, {createContext, useState} from 'react';
import {getErrorMessage} from "../../helpers/Utils";
import {Toast} from "../../components/common/Toast";
import CateringSectionService from "../../services/catering/CateringSectionService";

export const CateringSectionContext = createContext("CateringSectionContext");

const CateringSectionContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);
    const [cateringSectionList, setCateringSectionList] = useState([]);

    const getAllCateringSection = async params => {
        try {

            setLoading(true);

            const res = await CateringSectionService.getAllCateringSection(params);
            setCateringSectionList(res.data.content);
            setTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    return (
        <CateringSectionContext.Provider
            value={{
                loading,
                totalElements,
                cateringSectionList,
                getAllCateringSection,
            }}
        >
            {children}
        </CateringSectionContext.Provider>
    );
}

export default CateringSectionContextProvider;
